import { LockOutlined } from "@ant-design/icons";
import { Button, Card, Result, Typography } from "antd";
import { Link } from "react-router-dom";
import { AppearanceSettings } from "../workspace/AppearanceSettings";
import { usePortalStore } from "./store";

/**
 * ТЗ «Рабочие столы и персонализация» 31.10.2026, 6.1 (UXW-10, UXW-13): «Настройки» of a person of the cabinet —
 * the own look («Оформление») and the way to the change of the password, which keeps its own page and menu item.
 * Only the own preferences of this person: no right of the company administrator is needed, nothing else changes.
 */
export function PortalSettingsPage() {
  const enabled = usePortalStore((s) => Boolean(s.me?.feature_options?.use_personal_workspace));
  const header = (
    <div className="wms-page-header">
      <div>
        <h1>Настройки</h1>
        <div className="wms-subtitle">Личное оформление кабинета и пароль. Роли, права и данные не меняются.</div>
      </div>
    </div>
  );
  if (!enabled) {
    // the option is off: the address may still be opened from an old link — say so and give the ways on
    return (
      <div data-testid="portal-settings-off">
        {header}
        <Result
          status="info"
          title="Личное оформление сейчас выключено"
          subTitle="Склад ещё не включил выбор фона и цвета кнопок. Пароль можно сменить как раньше."
          extra={[
            <Link key="password" to="/portal/password">
              <Button type="primary">Сменить пароль</Button>
            </Link>,
            <Link key="home" to="/portal">
              <Button>На рабочий стол</Button>
            </Link>,
          ]}
        />
      </div>
    );
  }
  return (
    <div style={{ maxWidth: 1100 }} data-testid="portal-settings">
      {header}
      <Card title="Оформление" id="appearance" data-testid="portal-settings-appearance" style={{ marginBottom: 16 }}>
        <AppearanceSettings cabinet="portal" />
      </Card>
      <Card title="Пароль" size="small">
        <Typography.Paragraph type="secondary" style={{ marginBottom: 12 }}>
          Новый пароль — не короче 8 символов, хотя бы одна цифра. Смена пароля открывается на отдельной странице.
        </Typography.Paragraph>
        <Link to="/portal/password" data-testid="portal-settings-password">
          <Button icon={<LockOutlined />}>Сменить пароль</Button>
        </Link>
      </Card>
    </div>
  );
}
